import type { ModuleMigrationDef } from "@kubdee/sdk";

// ============================================================================
// 004_extra_hours_fields
//
// Persist scheduled overrun charges separately from user-entered additional
// charges. This prevents post-invoice edits from turning "ค่าล่วงเวลา" into a
// full new debit-note line instead of only billing the delta.
// ============================================================================

export const migration: ModuleMigrationDef = {
  key: "004_extra_hours_fields",
  version: "1.3.0",
  sql: `
ALTER TABLE \`car_rental_rental_bookings\` ADD COLUMN \`extra_hours\` integer DEFAULT 0 NOT NULL;
ALTER TABLE \`car_rental_rental_bookings\` ADD COLUMN \`extra_hours_charge\` real DEFAULT 0 NOT NULL;

UPDATE \`car_rental_rental_bookings\`
SET \`extra_hours_charge\` =
  ROUND(
    CASE
      WHEN (
        COALESCE(\`subtotal\`, 0)
        - (
          COALESCE(\`rental_amount\`, 0)
          + COALESCE(\`total_driver_cost\`, 0)
          + COALESCE(\`additional_charges\`, 0)
          - COALESCE(\`discount_amount\`, 0)
        )
      ) > 0
      THEN (
        COALESCE(\`subtotal\`, 0)
        - (
          COALESCE(\`rental_amount\`, 0)
          + COALESCE(\`total_driver_cost\`, 0)
          + COALESCE(\`additional_charges\`, 0)
          - COALESCE(\`discount_amount\`, 0)
        )
      )
      ELSE 0
    END,
    2
  )
WHERE COALESCE(\`extra_hours_charge\`, 0) = 0;
`.trim(),
};
